import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MDCasteCertificateBodyModel } from 'src/app/model/MDCasteCertificateBodyModel';
import { RegistrationModerationDocumentModel } from 'src/app/model/RegistrationModerationDocumentModel';

@Component({
  selector: 'app-secure-md-caste-certificate',
  templateUrl: './md-caste-certificate.component.html',
  styleUrls: []
})
export class MDCasteCertificateComponent implements OnInit {
  @Input() registrationModerationDocument: RegistrationModerationDocumentModel;
  verifyForm: FormGroup = new FormGroup({});
  isVerifyDisabled: boolean;
  verifyErrorMessage: string;
  @Output() onSubmit = new EventEmitter<MDCasteCertificateBodyModel>();
  departments: string[] = [];

  constructor() { }

  ngOnInit(): void { 
    console.log(this.registrationModerationDocument);
    this.verifyForm = new FormGroup({
      isDocReadable: new FormControl(null, [Validators.required]),
      hasBarcode: new FormControl(null, [Validators.required]),
    });
  }

  onSubmitVerify() {
    console.log('verify submit clicked', this.verifyForm);
    this.verifyErrorMessage = null;
    if (this.verifyForm.valid) {
      this.onSubmit.emit(new MDCasteCertificateBodyModel(
        this.verifyForm.value.isDocReadable,
        this.verifyForm.value.hasBarcode,
        ));
    }
    else {
      this.verifyErrorMessage = "Please enter all mandatory fields";
      this.isVerifyDisabled = false;
    }
  }
}
